import React from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSignupJobFunctionFilter } from './useSignupJobFunctionFilter';

export const SignupJobFunctionFilter = ({ value, setFilters, sharedList }) => {
  const { formSchema, defaultOptions, isLoading, onMenuOpen, onSearchChange, onSubmit } = useSignupJobFunctionFilter({
    sharedList,
    setFilters,
  });

  return (
    <Formik
      initialValues={{ signupJobFunctions: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="signupJobFunctions"
          label="Job function"
          placeholder="Add..."
          size="small"
          component={FormAsyncMultiSelect}
          loadOptions={onSearchChange}
          defaultOptions={defaultOptions}
          onMenuOpen={onMenuOpen}
          isLoading={isLoading}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

SignupJobFunctionFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
  sharedList: PropTypes.object,
};

SignupJobFunctionFilter.defaultProps = {
  value: [],
  sharedList: null,
};
